import { UPDATE_WORK_STATUS_WS, UPDATE_WORK_STATUS_WS_SUCCESS, UPDATE_WORK_STATUS_WS_ERROR } from './actionTypes';

const initialState = {
  errorUpdateWorkStatusWS: '',
  loadingUpdateWorkStatusWS: false,
  successUpdateWorkStatusWS: '',
};

const updateWorkStatusWS = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_WORK_STATUS_WS:
      state = {
        ...state,
        loadingUpdateWorkStatusWS: true,
      };
      break;
    case UPDATE_WORK_STATUS_WS_SUCCESS:
      state = {
        ...state,
        loadingUpdateWorkStatusWS: false,
        successUpdateWorkStatusWS: action.payload.message,
      };
      break;
    case UPDATE_WORK_STATUS_WS_ERROR:
      state = { ...state, errorUpdateWorkStatusWS: action.payload, loadingUpdateWorkStatusWS: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateWorkStatusWS;
